import React, { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

const Table = ({ type, column, data, onRowClick }) => {
    const navigate = useNavigate();

    const columns = useMemo(() => column, []);

    const table = useMaterialReactTable({
        columns,
        data,
        
        muiFilterTextFieldProps: {
            sx: { m: '0.5rem 0', width: '100%' },
            variant: 'outlined',
        },
        enableFacetedValues: false,
        muiTableBodyRowProps: ({ row }) => ({
            onClick: (event) => {
                console.info(event, row.id);
                console.log(row);
                
                onRowClick(row);
            },
            sx: {
                cursor: 'pointer', 
            },
        }),
        enableTopToolbar: true,
        enableDensityToggle: false,
        enableHiding: false,
        showSkeletons: false,
        enableColumnFilterModes: false,
        enableColumnActions: false,
        enableColumnOrdering: false,
        enableFullScreenToggle: false,
        enableColumnFilters:false,
        initialState: {
            showGlobalFilter: true,
        }
    });
    const handleExportRows = (rows) => {
        const rowData = rows.map((row) => row.original);
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };

    const handleExportData = () => {
        const csv = generateCsv(csvConfig)(data);
        download(csvConfig)(csv);
    };

    return (
        <>
            {type === 'people' && (
                <Stack direction={'row'}>
                    <Button
                        disabled={table.getRowModel().rows.length === 0}
                        onClick={() => handleExportRows(table.getRowModel().rows)}
                        startIcon={<FileDownloadIcon />}
                    >
                        Export Page Rows
                    </Button>
                    <Button
                        disabled={table.getRowModel().rows.length === 0}
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                    >
                        Export All Data
                    </Button>
                </Stack>
            )}
            <MaterialReactTable table={table} />
        </>
    );
};

export default Table;
